import React, { Component } from "react";
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  //Redirect,
  Switch,
} from "react-router-dom";
import store from "./store";
//import "./App.css";

import IndexPage from "./components/member/IndexPage";
import UserInfo from "./components/member/UserInfo";

import SignUpPage from "./components/auth/SignUpPage";
import LoginPage from "./components/auth/LoginPage";
import LogoutPage from "./components/auth/LogoutPage";
import ForgetPassword from "./components/auth/ForgetPassword";

import AccountPage from "./components/account/AccountPage";
import EmailVerification from "./components/account/EmailVerification";
import ChangeEmail from "./components/account/ChangeEmail";
import ChangeMobile from "./components/account/ChangeMobile";
import ChangePassword from "./components/account/ChangePassword";

import BindPage from "./components/bind/BindPage";
import RetrieveAccount from "./components/bind/RetrieveAccount";
import OrderList from "./components/order/OrderList";

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          <div className="App">
            <Switch>
             
              <Route exact path="/members" component={IndexPage} />
              <Route exact path="/members/user_info" component={UserInfo} />
              
              <Route exact path="/members/signup" component={SignUpPage} />
              <Route exact path="/members/login" component={LoginPage} />
              <Route exact path="/members/logout" component={LogoutPage} />
              <Route exact path="/members/forget_pwd" component={ForgetPassword} />
              
              <Route exact path="/members/account" component={AccountPage} />
              <Route exact path="/members/email_verification/:code/:sign" component={EmailVerification} />
              <Route exact path="/members/change_email" component={ChangeEmail} />
              <Route exact path="/members/change_mobile" component={ChangeMobile} />
              <Route exact path="/members/change_pwd" component={ChangePassword} />
              
              <Route exact path="/members/bind" component={BindPage} />
              <Route exact path="/members/retrieve_account/:role_id" component={RetrieveAccount} />
              <Route exact path="/members/order_list" component={OrderList} />

            </Switch>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
